import { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { LoyaltyType, SOLUTION_DISCOUNT_NAME } from '../../../../../graphql/promotions/models/get-promotions.models';
import { BonusType, IBonus } from '../../../../../graphql/bonuses/models/get-bonuses.models';

const VoucherDescription = ({ id }: { id: string }) => {
  const intl = useIntl();
  return <>{intl.formatMessage({ id }, { sup: (chunks: ReactNode) => <sup>{chunks}</sup> })}</>;
};

const withDescription = (promotion: IBonus, descriptionId: string): IBonus => ({
  ...promotion,
  description: <VoucherDescription id={descriptionId} />,
});

const getSecondVoucher = (value: number, id: string): IBonus => ({
  type: BonusType.loyalty,
  name: LoyaltyType.discountSecondPurchase,
  endDate: <FormattedMessage id="promotions.secondVoucher.endDate" />,
  description: <VoucherDescription id="promotions.secondVoucher.shortDescription" />,
  value,
  id: `${id}-second`,
  brands: [],
  packSize: null,
  externalLink: null,
  voucherType: null,
});

export const localizeSecondVoucher = (promotions: IBonus[]): IBonus[] =>
  promotions?.map((promotion) => promotion.name === LoyaltyType.discountSecondPurchase
    ? withDescription(promotion, 'promotions.secondVoucher.shortDescription')
    : promotion);

export const replaceWelcomeVoucher = (promotions: IBonus[]) => {
  const firstVoucher = promotions?.find((
    promotion,
  ) => promotion.name === LoyaltyType.discountFirstPurchase);
  const welcomeVouchers = firstVoucher ? [
    withDescription(firstVoucher, 'promotions.firstVoucher.shortDescription'),
    getSecondVoucher(firstVoucher.value as number, firstVoucher.id),
  ] : [];
  const promotionsNoWelcome = promotions?.filter((
    promotion,
  ) => promotion.name !== LoyaltyType.discountFirstPurchase)
    .map((promotion) => promotion.name === SOLUTION_DISCOUNT_NAME
      ? withDescription(promotion, 'promotions.solutionVoucher.shortDescription')
      : promotion);

  return [...promotionsNoWelcome, ...welcomeVouchers];
};
